<script lang="ts" setup>
import { AppSvgIcon } from '@libs/ui';

import type { FerryProductCardData } from '../../../models';

interface FerryCardRouteDetailsProps {
  content: FerryProductCardData;
}

const props = defineProps<FerryCardRouteDetailsProps>();
</script>

<template>
  <div class="ferry-card-route-details">
    <div class="origin">
      {{ props.content.fromPort.time }}
      <div class="port">
        <span class="desktop-port-name">
          {{ props.content.fromPort.country }}
        </span>
      </div>
    </div>

    <div class="time">
      <div class="duration">
        {{ props.content.details.time }}
      </div>
      <div class="separator">
        <div class="line" />
        <div class="icon-wrapper">
          <AppSvgIcon name="ferry" size="13" color="color-white" />
        </div>
      </div>
      <div class="stops">
        {{ props.content.details.shipName }}
      </div>
    </div>

    <div class="destination">
      {{ props.content.toPort.time }}
      <div class="port">
        <span class="desktop-port-name">
          {{ props.content.toPort.country }}
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ferry-card-route-details {
  --mid-block-width: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-16);
  width: 100%;
  @include for-less-or-equal-than-599-px {
    padding: 0;
  }

  .origin,
  .destination {
    display: flex;
    flex-direction: column;
    // align origin and destination columns mid block width
    flex-basis: calc(50%);
    gap: var(--spacing-4);
    @include font-label-xxl-bold;
    span {
      @include font-label-l-light;
    }

    .port {
      color: var(--color-secondary-60);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: var(--spacing-4);
      .desktop-port-name {
        display: block;
        @include for-less-or-equal-than-599-px {
          display: none;
        }
      }
    }
  }
  .origin {
    align-items: flex-end;
    .desktop-port-name {
      text-align: end;
    }
    .port {
      justify-content: end;
    }
  }
  .destination {
    align-items: flex-start;
  }

  .time {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;

    .duration {
      @include font-label-s-light;
      color: var(--color-secondary-60);
      padding-bottom: var(--spacing-12);
      @include for-less-or-equal-than-599-px {
        padding-bottom: var(--spacing-4);
      }
    }
    .separator {
      position: relative;
      width: 100%;
      height: var(--spacing-24);

      .line {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 1px;
        background: rgb(255, 255, 255);
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(36, 30, 61, 1) 50%,
          rgba(255, 255, 255, 1) 100%
        );
      }
      .icon-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: var(--color-primary-5);
        border-radius: var(--border-radius-20);
        padding: var(--spacing-4);
      }
    }
    .stops {
      color: var(--color-secondary-60);
      @include font-label-s-light;
      text-align: center;
      white-space: nowrap;
    }
  }
}
</style>
